export default function searchReducer(
    state: any = {
        loading: false,
        done: false,
        response: null,
        error: null,
        success: null,
        updated: null,
    },
    action: any) {

    switch (action.type) {

        /**
         *     Policy map reducer
         */
        case 'FETCH_SEARCH_PENDING': {
            return { ...state, loading: true, success: null }
        }

        case 'FETCH_SEARCH_REJECTED': {
            return { ...state, loading: false, error: action.payload, success: false }
        }

        case 'FETCH_SEARCH_FULFILLED': {
            return { ...state, loading: false, done: true, error: null, response: action.payload }
        }

        /**
         *     Default
         */
        default: {
            return { ...state }
        }

    }

}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/reducers/search.ts